export default __webpack_public_path__ + "static/media/img-use-04.d53bf2ef.jpg";